<template>
    <div class="bulma">
        <div class="modal is-active"
             v-if="show"
        >
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ trans.main_modal_title }}
                    </p>
                    <a
                        @click="closeModal"
                        :title="trans.close_modal_title"
                    >
                        <svg>
                            <use xlink:href="#icon-cross"></use>
                        </svg>
                    </a>
                </header>
                <section class="modal-card-body px-1">
                    <div>
                        <div class="tabs is-centered is-boxed search-type-button">
                            <ul>
                                <li :class="{ 'is-active': isSearchByAdress }">
                                    <a @click="searchMode(true)">
                                        <span>
                                            {{ trans.tab_search_by_adress }}
                                        </span>
                                    </a>
                                </li>
                                <li :class="{ 'is-active': !isSearchByAdress }">
                                    <a @click="searchMode(false)">
                                        <span>
                                            {{ trans.tab_search_by_coordinates }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="isSearchByAdress">
                            <div class="field columns">
                                <div class="control column is-12">
                                    <label class="label">
                                        {{ trans.label_address_field }}
                                    </label>
                                    <input
                                        :placeholder="trans.placeholder_adress"
                                        @keyup="adressTimeOut()"
                                        v-model="addressInput"
                                        class="input"
                                        id="search-adress"
                                        type="text"
                                    >
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="field is-flex columns">
                                <div class="column is-6">
                                    <label class="label">
                                        {{ trans.label_coordinates_latitude }}
                                    </label>
                                    <div class="control latitude-input">
                                        <input
                                            @keyup="coordinatesTimeOut()"
                                            v-model="latitudeInput"
                                            class="input"
                                            type="number"
                                            id="search-latitude"
                                            :placeholder="trans.placeholder_coordinates_latitude"
                                        >
                                    </div>
                                </div>
                                <div class="column is-6">
                                    <label class="label">
                                        {{ trans.label_coordinates_longitude }}
                                    </label>
                                    <div class="control longitude-input">
                                        <input
                                            @keyup="coordinatesTimeOut()"
                                            v-model="longitudeInput"
                                            class="input"
                                            type="number"
                                            id="search-longitude"
                                            :placeholder="trans.placeholder_coordinates_longitude"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="settings-container columns is-flex mb-0">
                        <div class="column is-6 is-flex slider-container pb-0">
                            <label class="label">
                                {{ trans.slider_title }}
                            </label>
                            <div class="slider-box is-flex">
                                <button
                                    :disabled="mapZoomMinValue == mapZoomValue"
                                    class="button is-small"
                                    @click="mapZoomValue--"
                                >
                                    <span class="icon is-small">
                                        <i class="fas fa-minus"></i>
                                    </span>
                                </button>
                                <input
                                    @change="changeMapZoom"
                                    :min="mapZoomMinValue"
                                    :max="mapZoomMaxValue"
                                    :value="mapZoom"
                                    type="range"
                                    id="zoom"
                                    name="zoom"
                                    class="slider"
                                >
                                <button
                                    :disabled="mapZoomMaxValue == mapZoomValue"
                                    class="button is-small"
                                    @click="mapZoomValue++">
                                    <span class="icon is-small">
                                        <i class="fas fa-plus"></i>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="column is-6 is-flex view-mode pb-0">
                            <div class="buttons has-addons">
                                <button
                                    @click="changeMapType('roadmap')"
                                    class="button"
                                    :class="{ 'is-info': !isSatelliteMode }"
                                >
                                    {{ trans.view_by_map }}
                                </button>
                                <button
                                    @click="changeMapType('satellite')"
                                    class="button"
                                    :class="{ 'is-info': isSatelliteMode }"
                                >
                                    {{ trans.view_by_satellite }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <iframe
                            width="700"
                            height="300"
                            :src="embedMapUrl"
                            allowfullscreen
                        >
                        </iframe>
                    </div>
                    <hr class="solid">
                    <div class="parameters-container">
                        <label class="parameters-title">
                            {{ trans.embed_map_parameters_title }}
                        </label>
                        <div class="columns">
                            <div class="column is-6">
                                <label class="label">
                                    {{ trans.label_parameter_width }}
                                </label>
                                <div class="is-flex">
                                    <input
                                        @keyup="checkEmbedMapSize()"
                                        v-model="embedMapWidth"
                                        class="input"
                                        type="number"
                                    >
                                    <a class="button is-static">
                                        px
                                    </a>
                                </div>
                                <p v-if="widthInputError" class="help is-danger">
                                    {{ widthInputError }}
                                </p>
                            </div>
                            <div class="column is-6">
                                <label class="label">
                                    {{ trans.label_parameter_height }}
                                </label>
                                <div class="is-flex">
                                    <input
                                        @keyup="checkEmbedMapSize()"
                                        v-model="embedMapHeight"
                                        class="input"
                                        type="number"
                                    >
                                    <a class="button is-static">
                                        px
                                    </a>
                                </div>
                                <p v-if="heightInputError" class="help is-danger">
                                    {{ heightInputError }}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button @click="closeModal" class="button cancel-button">
                        {{ trans.cancel_button }}
                    </button>
                    <button @click="embedMap" class="button save-button">
                        {{ trans.insert_button }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "EmbedMapModal",
    data() {
        return {
            mapType: 'roadmap',
            mapZoomValue: 10,
            mapZoomMinValue: 0,
            mapZoomMaxValue: 21,
            addressValue: this.initTrans.embed_map_default_city,
            latitudeValue: null,
            longitudeValue: null,
            isSearchByAdress: true,
            isSatelliteMode: false,
            addressInput: null,
            latitudeInput: null,
            longitudeInput: null,
            sliderValue: null,
            timeout: null,
            isCoordinatesMode: false,
            coordinates: "",
            embedMapWidth: 560,
            embedMapHeight: 314,
            inputEmbedMapWidth: null,
            inputEmbedMapHeight: null,
            widthInputError: false,
            heightInputError: false,
        }
    },
    props: {
        initTrans: Object,
        initEmbedSizeLimits: Object,
        initMapApiKey: String,
    },
    mounted() {
        this.setTrans(this.initTrans);
        this.setMapApiKey(this.initMapApiKey);
    },
    computed: {
        ...mapState('editor', [
            'editor'
        ]),
        ...mapState('embedMapManager', {
            show: 'embedMapModalIsShown',
        }),
        ...mapGetters('embedMapManager', [
            'trans',
            'mapApiKey',
        ]),
        mapZoom() {
            return this.mapZoomValue;
        },
        embedMapUrl() {
            if (this.isCoordinatesMode) {
                return 'https://www.google.com/maps/embed/v1/view?key='
                    + this.mapApiKey
                    + this.coordinates
                    + '&maptype=' + this.mapType
                    + '&zoom=' + this.mapZoom;
            }

            return 'https://www.google.com/maps/embed/v1/place?key='
                + this.mapApiKey
                + '&q=' + this.addressValue
                + '&maptype=' + this.mapType
                + '&zoom=' + this.mapZoom;
        },
    },
    methods: {
        ...mapActions('embedMapManager', [
            'setTrans',
            'setMapApiKey',
            'showEmbedMapModal',
            'hideEmbedMapModal',
        ]),
        changeMapZoom() {
            this.sliderValue = document.getElementById("zoom").value;
            this.mapZoomValue = this.sliderValue;
        },
        setDefaultState() {
            this.addressInput = null;
            this.addressValue = this.trans.embed_map_default_city;
            this.coordinates = "";
            this.isCoordinatesMode = false;
            this.isSatelliteMode = false;
            this.isSearchByAdress = true;
            this.latitudeInput = null;
            this.latitudeValue = null;
            this.longitudeInput = null;
            this.longitudeValue = null;
            this.mapType = "roadmap";
            this.mapZoomValue = 10;
            this.embedMapWidth = 560;
            this.embedMapHeight = 314;
            this.inputEmbedMapWidth = null;
            this.inputEmbedMapHeight = null;
            this.widthInputError = false;
            this.heightInputError = false;
        },
        closeModal() {
            this.hideEmbedMapModal();
            this.setDefaultState();
        },
        changeMapType(value) {
            value === 'satellite' ? this.isSatelliteMode = true : this.isSatelliteMode = false;
            return this.mapType = value;
        },
        adressTimeOut() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.addressValue = this.addressInput;
                if (this.addressValue === '') {
                    this.addressValue = this.trans.embed_map_default_city;
                }
            }, 1000);
        },
        coordinatesTimeOut() {
            // Функция проверки что пользователь перестал вводить значение
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.latitudeValue = this.latitudeInput;
                this.longitudeValue = this.longitudeInput;
                if (this.latitudeValue && this.longitudeValue) {
                    this.coordinates = '&center=' + this.latitudeValue + ',' + this.longitudeValue;
                    this.isCoordinatesMode = true;
                }
            }, 1000);
        },
        searchMode(isType) {
            if (isType) {
                this.isSearchByAdress = isType;
                this.isCoordinatesMode = false;
            } else {
                this.isSearchByAdress = false;
                if (this.latitudeValue && this.longitudeValue) {
                    this.isCoordinatesMode = true;
                }
            }
        },
        checkEmbedMapSize() {
            this.widthInputError = this.validateSizeField(this.embedMapWidth, 'width');
            this.heightInputError = this.validateSizeField(this.embedMapHeight, 'height');
        },
        validateSizeField(fieldValue, sizeType) {
            if (fieldValue === '') {
                return this.trans.error_input_embed_map_empty;
            }

            let limitKey = null;

            if (fieldValue < this.initEmbedSizeLimits[sizeType]['min']) {
                limitKey = 'min';
            }

            if (fieldValue > this.initEmbedSizeLimits[sizeType]['max']) {
                limitKey = 'max';
            }

            if (limitKey) {
                let errorKey = `error_input_embed_map_${limitKey}_${sizeType}_size`;

                return this.replaceWildcards(this.trans[errorKey], {
                    value: this.initEmbedSizeLimits[sizeType][limitKey],
                });
            }
        },
        embedMap() {
            if (!this.widthInputError && !this.heightInputError) {
                let content, url, width, height;
                url = this.embedMapUrl;
                width = this.embedMapWidth;
                height = this.embedMapHeight;
                content = `<p style="text-align: center;"><iframe
                            width="${width}"
                            height="${height}"
                            style="border:0"
                            src="${url}" allowfullscreen>
                        </iframe></p>`;

                this.editor.insertContent(content);
                this.closeModal();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .bulma .modal-background {
        background-color: rgba(255,255,255,.75);
    }

    .bulma .modal-card {
        background-color: $white;
        border-color: #ccc;
        border-radius: 3px;
        border-style: solid;
        border-width: 1px;
        box-shadow: 0 16px 16px -10px rgba(34,47,62,.15), 0 0 40px 1px rgba(34,47,62,.15);
    }

    .bulma .modal-card-head {
        background-color: $white;
        height: 25px;
        padding-top: 25px;
        padding-bottom: 25px;
    }

    svg {
        width: 16px;
        height: 16px;
        fill: $grey;
        &:hover {
            fill: $danger;
        }
    }

    .bulma .modal-card-title {
        color: black;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
    }

    .bulma .modal-card {
        width: 700px;
        margin-top: 8px;
    }

    .search-type-button {
        margin-bottom: 0.5rem !important;
    }

    .content {
        height: 300px;
        padding-left: 0px;
        padding-right: 0px;
        margin-bottom: 0.5rem !important;
        &:hover {
            cursor: not-allowed;
        }
    }

    iframe {
        padding-top: 10px;
        pointer-events: none;
        border: 0;
    }

    .slider-container {
        flex-direction: column;
    }

    .settings-container {
        margin-top: 2px;
    }

    .view-mode {
        justify-content: flex-end;
        align-items: flex-end;
    }

    .label {
        display: block;
        font-size: 16px;
        font-weight: 100;
        margin-bottom: 8px;
    }

    hr.solid {
        border-top: 1px solid #dbdbdb;
        margin-top: 14px;
        margin-bottom: 8px;
    }

    button i {
        &::before {
            color: #545c6a;
        }
    }

    .latitude-input {

        padding-right: 13px;
    }

    input[type=range] {
        height: 27px;
        -webkit-appearance: none;
        margin: 0;
        width: 100%;
    }
    input[type=range]:focus {
        outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 7px;
        cursor: pointer;
        animate: 0.2s;
        background: #3273dc;
        border-radius: 0px;
        border: 1px solid #000000;
    }
    input[type=range]::-webkit-slider-thumb {
        border: 1px solid #000000;
        height: 25px;
        width: 11px;
        border-radius: 0px;
        background: #dbdbdb;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -10.5px;
    }
    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #3273dc;
    }
    input[type=range]::-moz-range-track {
        width: 100%;
        height: 7px;
        cursor: pointer;
        animate: 0.2s;
        box-shadow: 1px 1px 1px #000000;
        background: #3273dc;
        border-radius: 0px;
        border: 1px solid #000000;
    }
    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #000000;
        border: 1px solid #000000;
        height: 26px;
        width: 13px;
        border-radius: 0px;
        background: #dbdbdb;
        cursor: pointer;
    }
    input[type=range]::-ms-track {
        width: 100%;
        height: 7px;
        cursor: pointer;
        animate: 0.2s;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }
    input[type=range]::-ms-fill-lower {
        background: #3273dc;
        border: 1px solid #000000;
        border-radius: 0px;
        box-shadow: 1px 1px 1px #000000;
    }
    input[type=range]::-ms-fill-upper {
        background: #3273dc;
        border: 1px solid #000000;
        border-radius: 0px;
        box-shadow: 1px 1px 1px #000000;
    }
    input[type=range]::-ms-thumb {
        margin-top: 1px;
        box-shadow: 1px 1px 1px #000000;
        border: 1px solid #000000;
        height: 26px;
        width: 13px;
        border-radius: 0px;
        background: #dbdbdb;
        cursor: pointer;
    }
    input[type=range]:focus::-ms-fill-lower {
        background: #3273dc;
    }
    input[type=range]:focus::-ms-fill-upper {
        background: #3273dc;
    }

    .bulma .tabs.is-fullwidth li {
         flex-grow: 0;
         flex-shrink: 0;
    }

    .bulma .tabs.is-toggle li.is-active a {
        border-radius: 0;
        width: 80px;
    }

    .bulma .tabs.is-toggle li:last-child a {
        border-radius: 0;
        width: 80px;
    }

    .bulma .tabs.is-toggle ul {
        border-bottom: none;
        align-items: flex-end;
    }

    .bulma .modal-card-body {
        padding: 8px;
    }

    .bulma .modal-card-foot {
        padding: 0px;
    }

    .parameters-container {
        padding-bottom: 8px;
    }

    .parameters-title {
        font-size: 1rem;
        font-weight: 600;
        display: block;
        margin-bottom: 5px;
    }

    .input {
        border-radius: 0px;
    }

    .is-static {
        border-radius: 0px;
    }

    .cancel-button {
        width: 140px;
        height: 38px !important;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 16px !important;
        border-radius: 0;
        background-color: #e3e3e3;
        color: #222f3e;
        margin-right: 19px;
        &:hover {
            background-color: #d6d6d6;
            border-color: #d6d6d6;
        }
    }

    .save-button {
        width: 140px;
        height: 38px !important;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 16px !important;
        border-radius: 0;
        background-color: #207ab7;
        color: $white;
        margin-left: 19px;
        &:hover {
            background-color: #185d8c;
            border-color: #185d8c;
            color: $white;
        }
    }

    .bulma .button.is-success {
        border-radius: 0px;
        background-color: #f1f1f1;
        padding-top: 6px;
        padding-bottom: 6px;
        width: 100%;
        color: $info;
        &:hover {
            background-color: #FAFAFA;
            color: $info;
        }
    }
</style>
